import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

export default function IdleWarningModal({ onStay, onLogout, countdownSecs = 60 }) {
  const [remaining, setRemaining] = useState(countdownSecs);

  useEffect(() => {
    const t = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) { clearInterval(t); onLogout(); return 0; }
        return r - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [onLogout]);

  return (
    <div className="fixed inset-0 bg-black/60 z-[200] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-7 text-center">
        <div className="w-14 h-14 bg-amber-50 border border-amber-200 rounded-full flex items-center justify-center mx-auto mb-4">
          <Clock size={26} className="text-amber-600" />
        </div>
        <h2 className="text-[18px] font-bold text-slate-900 mb-2">Still there?</h2>
        <p className="text-[13px] text-slate-500 mb-1">
          You've been inactive. For security, you'll be logged out in:
        </p>
        <div className="text-[42px] font-extrabold text-slate-900 my-4 tabular-nums">
          {remaining}s
        </div>
        <p className="text-[12px] text-amber-700 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2 mb-5">
          Your WhatsApp connection will also be disconnected.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onLogout}
            className="flex-1 h-10 border border-slate-200 rounded-xl text-[13px] font-semibold text-slate-600 hover:bg-slate-50 transition"
          >
            Log out now
          </button>
          <button
            onClick={onStay}
            className="flex-1 h-10 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-[13px] font-semibold transition"
          >
            Stay logged in
          </button>
        </div>
      </div>
    </div>
  );
}
